import { render, staticRenderFns } from "./GroupMemberTable.vue?vue&type=template&id=c3360196&"
import script from "./GroupMemberTable.vue?vue&type=script&lang=ts&"
export * from "./GroupMemberTable.vue?vue&type=script&lang=ts&"
import style0 from "./GroupMemberTable.vue?vue&type=style&index=0&id=c3360196&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports